import React, { FC } from "react";
import FinishLine from "./FinishLine";
import HighFive from "./HighFive";
import ProgressIndicator from "../ProgressIndicator/ProgressIndicator";

import Celebration from "./Celebration";
import Joyride from "./Joyride";
import YoungAndHappy from "./YoungAndHappy";

import styles from "./SubmittedMessage.module.scss";

const notificationDrawing = [HighFive, Celebration, Joyride, YoungAndHappy];

const randomNumber = Math.floor(Math.random() * notificationDrawing.length);

const Component = notificationDrawing[randomNumber];

const SubmittedMessage: FC<{ numberOfProjects?: number; path?: string }> = ({
  numberOfProjects = 8,
  path,
}) => {
  return (
    <>
      <div className={styles.SubmittedMessage}>
        {numberOfProjects !== 8 && <Component />}

        {numberOfProjects === 8 && <FinishLine />}

        <h2>Submitted Successfully</h2>
        {numberOfProjects === 1 && (
          <p>
            Good job! You have completed your first challenge in{" "}
            <b>{path} path.</b>
          </p>
        )}

        {numberOfProjects > 1 && numberOfProjects < 8 && (
          <p>
            You have completed <b>{numberOfProjects}</b> challenges in{" "}
            <b>{path} path</b>. Keep it up!
          </p>
        )}

        {numberOfProjects === 8 && (
          <p>
            Congratulation! You have completed <b>{path} path</b>. Don't forget
            to apply for a certificate.
          </p>
        )}
      </div>
      <ProgressIndicator numberOfProjects={numberOfProjects} />
    </>
  );
};

export default SubmittedMessage;
